import { render, staticRenderFns } from "./RecipeTag.vue?vue&type=template&id=a23482aa&"
import script from "./RecipeTag.vue?vue&type=script&lang=js&"
export * from "./RecipeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports